function decodeEmails(element) {
    const reg = /LOADEMAIL\[([^\]]*)\]DOMAIN\[([^\]]*)\]/;

    if (element) {
        let itemHtml = element.innerHTML;

        if (reg.test(itemHtml)) {
            itemHtml = itemHtml.replace(reg, emailResult);
        }
        element.innerHTML = itemHtml;
    } else {
        const antiSpiderElements = document.querySelectorAll(".anti-spider");
        
        for (let i = 0; i < antiSpiderElements.length; i++) {
            const item = antiSpiderElements[i];
            let itemHtml = item.innerHTML;

            if (reg.test(itemHtml)) {
                itemHtml = itemHtml.replace(reg, emailResult);
            }
            item.innerHTML = itemHtml;
            //item.classList.remove("anti-spider");
        }
    }
}

function emailResult(str, login, domain) {
    return "<a class='anti-spider__link' " + "href=\'mailto:" + login + "@" + domain + "\'>" + login + "@" + domain + "</a>";
}

export default decodeEmails;


// WEBPACK FOOTER //
// ./uPortal/Content/js/Plugins/AntiSpider/index.js